import Button from '@rio-cloud/rio-uikit/Button';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { FormattedMessage } from 'react-intl';
import { deviceTypeToDisplayedString } from '../TelematicsName';
import type { AssociatedDevice, Device } from '../types';
import { DeviceType } from './types';

export type DeviceListDeletionButtonProperties = {
    disabled?: boolean;
    associatedDevice: AssociatedDevice;
    allAssociatedDevices: AssociatedDevice[];
    onDisassociationButtonClick: (devicesToDelete: Device[]) => void;
};

export const DeviceListDeletionButton = (props: DeviceListDeletionButtonProperties) => {
    const autoTrackingKey = `disassociate-device-${props.associatedDevice.device.type}`;

    const defaultButton = (
        <Button
            disabled={props.disabled}
            className='btn-link-inline'
            variant={Button.VARIANT_LINK_INLINE}
            id='disassociateDevice'
            data-cy='disassociate-device'
            autoTrackingKey={autoTrackingKey}
            onClick={() => props.onDisassociationButtonClick([props.associatedDevice.device])}
        >
            <span className='uikit-icon icon-trash' />
        </Button>
    );

    if (!includesTbm3VcmPair(props.allAssociatedDevices)) {
        return defaultButton;
    }

    if (props.associatedDevice.device.type === DeviceType.VCM) {
        return (
            <OverlayTrigger
                placement='top'
                overlay={
                    <Tooltip id='tooltip' allowOnTouch data-cy='association-deletion-tooltip'>
                        <FormattedMessage
                            id={'intl-msg:association.vcm.delete.tooltip.content'}
                            values={{
                                br: <br />,
                                vcm: deviceTypeToDisplayedString(DeviceType.VCM),
                                tbm3: deviceTypeToDisplayedString(DeviceType.TBM3),
                            }}
                        />
                    </Tooltip>
                }
            >
                <span className='cursor-not-allowed'>
                    <Button
                        disabled
                        className='btn-link-inline'
                        variant={Button.VARIANT_LINK_INLINE}
                        autoTrackingKey={autoTrackingKey}
                        id='disassociateDevice'
                        data-cy='disassociate-device'
                    >
                        <span className='uikit-icon icon-trash' />
                    </Button>
                </span>
            </OverlayTrigger>
        );
    } else if (props.associatedDevice.device.type === DeviceType.TBM3) {
        const devices = props.allAssociatedDevices
            .filter(it => it.device.type === DeviceType.TBM3 || it.device.type === DeviceType.VCM)
            .map(it => it.device);

        return (
            <Button
                className='btn-link-inline'
                variant={Button.VARIANT_LINK_INLINE}
                id='disassociateDevice'
                data-cy='disassociate-device'
                autoTrackingKey={autoTrackingKey}
                disabled={props.disabled}
                onClick={() => props.onDisassociationButtonClick(devices)}
            >
                <span className='uikit-icon icon-trash' />
            </Button>
        );
    } else {
        return defaultButton;
    }
};

const includesTbm3VcmPair = (associatedDevices: AssociatedDevice[]): boolean => {
    const relevantDeviceTypes = associatedDevices
        .map(it => it.device.type)
        .filter(type => type === DeviceType.VCM || type === DeviceType.TBM3);
    return (
        relevantDeviceTypes.length === 2 &&
        relevantDeviceTypes.includes(DeviceType.VCM) &&
        relevantDeviceTypes.includes(DeviceType.TBM3)
    );
};
